import { RealisationHourtype } from '../../app/classes/realisation';
import { Environment, PeriodType } from '../../app/environment';
import { entityTypes } from './entitytypes';
import { Roles } from './roles';
import { PlanningStatus } from './status.planning';
import { TEMPLATE_MAP } from './templates/template-registry';

export const envBasics: Environment = {
    allowWorksWith: true,
    apiEndpoint: '',
    appTitle: 'Track Line',
    asphaltexecutor: null,
    asphaltPlanning: false,
    companyAddress: {
        street: 'Handelstraat',
        housenumber: '2',
        zipcode: '4143 HT',
        town: 'Leerdam',
    },
    checkHoursBundle: 'planning_id',
    dayReportPlanning: false,
    defaultStand: false,
    disableAfas: true,
    employeeEmployees: true,
    employeePlanning: false,
    enableDayreport: true,
    entitytypes: entityTypes,
    entitytypeTemplates: TEMPLATE_MAP,
    executor: Roles.Foreman,
    executorName: 'voorman',
    executorNamePlural: 'voormannen',
    executorPlanning: false,
    executors: [Roles.Foreman],
    feEndpoint: 'http://localhost:4204/',
    fromEmail: 'planning@trackline.nl',
    inventarizePlanning: true,
    leaveHourTypes: [
        { value: RealisationHourtype.illness, label: 'Ziek' },
        { value: RealisationHourtype.time_for_time, label: 'Spaaruren' },
        { value: RealisationHourtype.paid_leave, label: 'Doorbetaald verlof' },
        { value: RealisationHourtype.short_absence, label: 'Kort verzuim' },
        { value: RealisationHourtype.education, label: 'Scholing' },
        { value: RealisationHourtype.bank_holiday, label: 'Feestdag' },
        { value: RealisationHourtype.special_leave, label: 'Bijzonder verlof' },
        { value: RealisationHourtype.additional_parental, label: 'Aanv. geb verl. + ouderschapsv' },
    ],
    microsoftLogin: true,
    name: 'Track Line B.V.',
    officePhoneNumber: '+31345523893',
    onlyAddRealisationOnPlanning: true,
    onlyOvertime: false,
    orderDirect: true,
    subProjects: false,
    periodType: PeriodType.Month,
    periodSettlementColums: {
        '135V': false,
        '145V': false,
        '200V': true,
        100: false,
        125: false,
        135: false,
        145: false,
        150: true,
        200: true,
        '200Z': true,
        Z: false,
    },
    planningEntityTypes: [
        entityTypes.markings,
        entityTypes.blast,
        entityTypes.wipe,
        entityTypes.inventorize,
        entityTypes.workplace,
    ],
    planningTableDialog: 'trackline',
    platform: 'trackline',
    production: false,
    projectIdentifier: /\b(\d{4,})\b/,
    projectmanager: Roles.Projectmanager,
    // General KAM reports funnel into DvdS, not per subsidiary, so this stays disabled here.
    publicTicketForm: false,
    realisationHourTypes: [
        {
            value: RealisationHourtype.loading_unloading,
            label: 'Laden/lossen',
            sortOrder: 0,
        },
        { value: RealisationHourtype.driving_to, label: 'Heenreis naar locatie', sortOrder: 1 },
        { value: RealisationHourtype.worktime, label: 'Productie', sortOrder: 2 },
        {
            value: RealisationHourtype.driving_back,
            label: 'Terugreis van locatie',
            sortOrder: 3,
        },
        {
            value: RealisationHourtype.repair_maintenance,
            label: 'Reparatie-/Onderhoud materieel',
            sortOrder: 4,
        },
        { value: RealisationHourtype.time_for_time, label: 'Spaaruren' },
        { value: RealisationHourtype.paid_leave, label: 'Doorbetaald verlof' },
        { value: RealisationHourtype.short_absence, label: 'Kort verzuim' },
        { value: RealisationHourtype.sleep, label: 'Slapen' },
        { value: RealisationHourtype.special_leave, label: 'Bijzonder verlof' },
        { value: RealisationHourtype.education, label: 'Scholing' },
    ],
    roles: {
        AfasAuth: Roles.AfasAuth,
        AiReports: Roles.AiReports,
        Codalt: Roles.Codalt,
        Employee: Roles.Employee,
        EmployeeBlast: Roles.EmployeeBlast,
        EmployeeInventorize: Roles.EmployeeInventorize,
        EmployeeMarkings: Roles.EmployeeMarkings,
        EmployeeWipe: Roles.EmployeeWipe,
        Foreman: Roles.Foreman,
        FormerEmployee: Roles.FormerEmployee,
        Hourcheck: Roles.Hourcheck,
        HoursExtended: Roles.HoursExtended,
        Hourwriter: Roles.Hourwriter,
        Hrm: Roles.Hrm,
        Kam: Roles.Kam,
        Leave: Roles.Leave,
        LeaveManagement: Roles.LeaveManagement,
        Management: Roles.Management,
        Planner: Roles.Planner,
        PlanningAlwaysRead: Roles.PlanningAlwaysRead,
        ProjectManagement: Roles.ProjectManagement,
        Projectmanager: Roles.Projectmanager,
        UserManagement: Roles.UserManagement,
    } as const,
    rootPage: 'weekplanning',
    rootPageName: 'Weekplanning',
    shortName: 'Track Line',
    status: {
        Planning: {
            PlanningBehoefte: PlanningStatus.PlanningBehoefte,
            PlanningGarantiewerk: PlanningStatus.PlanningGarantiewerk,
            PlanningGeblokkeerd: PlanningStatus.PlanningGeblokkeerd,
            PlanningGepland: PlanningStatus.PlanningGepland,
            PlanningBevestigd: PlanningStatus.PlanningBevestigd,
            PlanningRegen: PlanningStatus.PlanningRegen,
            PlanningReservering: PlanningStatus.PlanningReservering,
            PlanningSlaapdag: PlanningStatus.PlanningSlaapdag,
            PlanningVerwerkt: PlanningStatus.PlanningVerwerkt,
        },
    } as const,
    test: false,
    titleAppend: ' - Track Line B.V.',
    transportPlanning: false,
    travelTime: false,
    vkmPlanning: false,
    weekPlanning: true,
    weekPlanningEmployees: [
        Roles.Foreman,
        Roles.EmployeeBlast,
        Roles.EmployeeMarkings,
        Roles.EmployeeWipe,
        Roles.EmployeeInventorize,
    ],
    weekScheduleComponent: 'planning',
    wsEndpoint: 'ws://localhost:1340',
};
